import { t } from '@/i18n'
import { CustomError } from '@/utils/custom-error'
import { isElectron } from '@/utils/device-type'

import type { CashMachineOptions, ICashMachine } from './types'

class CashGuardDirect implements ICashMachine {
  private ipcRenderer: any

  init({ port, inputAmountListener, totalAmountListener }: CashMachineOptions) {
    if (!isElectron) return
    this.ipcRenderer = window.require('electron').ipcRenderer
    this.ipcRenderer.on('cashguard:inputAmountUpdated', (_: unknown, amount: number) =>
      inputAmountListener(amount)
    )
    this.ipcRenderer.on('cashguard:totalAmountUpdated', (_: unknown, amount: number) =>
      totalAmountListener(amount)
    )
    return this.ipcRenderer.invoke('cashguard:init', port)
  }

  async charge(amount: number) {
    const result = await this.ipcRenderer.invoke('cashguard:charge', amount)
    if (typeof result === 'object' && result?.insufficientChange) {
      throw new CustomError('INSUFFICIENT_CHANGE', t('cash-machine-status.insufficient-change'))
    }
    return result
  }

  payIn(amount: number) {
    return this.ipcRenderer.invoke('cashguard:payIn', amount)
  }

  async payOut(amount: number) {
    const result = await this.ipcRenderer.invoke('cashguard:payOut', amount)
    if (typeof result === 'object' && result?.insufficientChange) {
      throw new CustomError('INSUFFICIENT_CHANGE', t('cash-machine-status.insufficient-change'))
    }
    return result
  }

  cancel() {
    return this.ipcRenderer.invoke('cashguard:cancel')
  }

  close() {
    return this.ipcRenderer.invoke('cashguard:close')
  }
}

export default new CashGuardDirect()
